import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Provider } from "react-redux";
import store from "Root/profile/redux/store";
import UpsellPageContent from "../upsellPageContent/index";
import { useSelector } from "react-redux";
import PLP from "../../PLP";
import NavBar from "Root/profile/components/Navigation/NavBar";
const UpsellPage = () => {
    const user = useSelector((state) => state.user);
    return (_jsx(_Fragment, { children: user.user_class === "byb" ? (_jsxs(_Fragment, { children: [_jsx(NavBar, { userName: user.full_name, showTop: false, userLoggedIn: true }), _jsx(PLP, {})] })) : (_jsx(Provider, { store: store, children: _jsx(UpsellPageContent, {}) })) }));
};
export default UpsellPage;
